import React, { useState } from 'react';
import { ResetPasswordRequestForm } from 'components/ResetPasswordRequestForm';
import { useDispatch, useSelector } from 'react-redux';
import { resetPasswordEmailRequest } from 'store/auth/actions';
import {
  getAuthLoading,
  //getAuthSuccess,
} from 'store/auth/selectors';
import { Helmet } from 'react-helmet-async';
import { ResetPasswordSuccess } from 'components/ResetPasswordRequestForm/success';
import { UserDetails } from 'store/signup/models';
import { useTranslation } from 'react-i18next';

export const ResetPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  //const [sentEmail, setSentEmail] = useState<string>('');
  const sendResetPasswordEmail = (forgotEmail: string) => {
    const user = { forgotEmail } as UserDetails;
    dispatch(resetPasswordEmailRequest(user));
    //setSentEmail(forgotEmail);
  };
  const loading = useSelector(getAuthLoading);

  return (
    <div>
      <Helmet>
        <title>{`${t('forgot-password.page-title')} | ${process.env.PROJECT_NAME}`}</title>
        <meta
          name="description"
          content={t('forgot-password.page-meta-description')}
        />
      </Helmet>
      {/* {sentEmail ? (
        <ResetPasswordSuccess sentEmail={sentEmail} />
      ) : ( */}
      <ResetPasswordRequestForm
        onRequestResetPassword={sendResetPasswordEmail}
        loading={loading}
      />
      {/* )} */}
    </div>
  );
};
